import React, { Component } from 'react';

import { fetchProducts, getItemHistories } from '../../actions/home';

import auth from '../../utils/auth';
import { default as config } from '../../config';

import Loading from '../Loading';
import Alert from 'react-s-alert';
import { splitCSV } from '../../utils';

const arrayDiff = (a, b) => {
    return a.filter((i) => b.indexOf(i) < 0);
};

export class Import extends Component {
    static fr = window.FileReader ? new window.FileReader() : null;
    state = {
        inProgress: false,
        products: {
            data: []
        },
        alreadySelectedVals: [],
        error: null
    };

    handleAddToCart = async () => {
        let { cart } = this.props || {};
        if (!this.props.session.is_authenticated) {
            Alert.error('You must be logged in to add to cart.');
            return;
        }
        let billingAddress = this.props.addresses?.data?.find((adr) => adr.primary_billing);
        let products = this.state.products.data.filter((p) => p.is_selected);
        let cartTerritory = (billingAddress && billingAddress.country) || auth.getDefaultTerritory();
        let territory = [cartTerritory, 'WORLD'];
        let canAdd = true;
        products.forEach((item) => {
            let hasRights = false;
            let itemRights = item.sales_territory_rights;
            itemRights = typeof itemRights === 'string' ? [itemRights] : itemRights;

            for (const ter of territory) {
                hasRights = hasRights || itemRights.includes(ter);
            }

            if (!hasRights) {
                Alert.error(`${item.title} is not available in your territory.`);
                canAdd = false;
                return;
            }
            // is this an SOP cart?
            if (!!cart.sop_id) {
                let sopSub = this.props.sop.find((sub) => sub.internal_id === cart.sop_id);
                // Only allowed formats based on subscription can be added.
                if (!config.allowed_sop_formats[sopSub.format].includes(item.format)) {
                    Alert.error(`You cannot add ${item.title} to your ${sopSub.format} queue.`);
                    canAdd = false;
                    return;
                }
            }

            // is this a PIF cart?
            if (!!cart.is_pif) {
                // Only allowed PIF formats can be added.
                if (!config.allowed_pif_formats.includes(item.format)) {
                    Alert.error(`You cannot add a ${item.title} to Play it Forward.`);
                    canAdd = false;
                }
            }
        });
        if (!canAdd) {
            return;
        }
        await this.props.handleAddItemsToCart(this.state.products.data || []);
        this.setState({
            products: {
                data: []
            }
        });
    };

    fetchProducts = async (value) => {
        if (!value.trim()) {
            this.setState({
                error: 'No ISBNs listed'
            });
            return;
        }
        let cartItemISBNs =
            this.props.cart?.items?.filter((item) => item?.isbn && item)?.map((item) => item?.isbn && item.isbn) || [];
        let billingAddress = this.props.addresses?.find((adr) => adr.primary_billing);
        let territory = (billingAddress && billingAddress.country) || auth.getDefaultTerritory();
        let vals = splitCSV(value);

        let alreadySelectedVals = vals.filter((val) => cartItemISBNs?.includes(val) && val) || []; //filter out products not in cart

        this.setState({
            inProgress: true,
            alreadySelectedVals
        });
        if (vals) {
            try {
                let resp = await fetchProducts(
                    '/products/search',
                    { key: 'title', order: 'asc' },
                    { isbn: vals },
                    territory,
                    vals.length
                );
                let isbns = resp.data.data.map((p) => p.isbn);
                if (this.props.account_info) {
                    await getItemHistories(
                        resp.data.data.map((item) => item.sku),
                        this.props.account_info._id,
                        this.props.orgId
                    ).then((orderResp) => {
                        resp.data.data.forEach((prod) => {
                            if (!prod.history) {
                                prod.history = [];
                            }
                            orderResp.data.data.forEach((order) => {
                                if (order.items.includes(prod.sku)) {
                                    prod.history.push(order);
                                }
                            });
                        });
                        this.setState({
                            inProgress: false,
                            allSelected: true,
                            products: {
                                ...(resp?.data || {}),
                                data: [
                                    ...resp.data.data.map((p) => {
                                        p.qty = 1;
                                        p.is_selected = true;
                                        return p;
                                    }),
                                    ...this.props.cart.items.map((p) => {
                                        p.qty = 1;
                                        p.is_selected = true;
                                        return p;
                                    })
                                ]
                            },
                            error: arrayDiff(vals, isbns).length
                                ? `We could not find: ${arrayDiff(vals, isbns).join(', ')}`
                                : null
                        });
                    });
                    this.handleAddToCart();
                    return;
                }
                this.setState({
                    inProgress: false,
                    allSelected: true,
                    products: {
                        ...(resp?.data || {}),
                        data: [
                            ...resp.data.data.map((p) => {
                                p.qty = 1;
                                p.is_selected = true;
                                return p;
                            }),
                            ...this.props.cart.items.map((p) => {
                                p.qty = 1;
                                p.is_selected = true;
                                return p;
                            })
                        ]
                    },
                    error: arrayDiff(vals, isbns).length
                        ? `We could not find: ${arrayDiff(vals, isbns).join(', ')}`
                        : null
                });
                this.handleAddToCart();
            } catch (err) {
                console.error(err);
            }
        }
    };

    inputChange = () => {
        window.sessionStorage.setItem('last_import', this._input.value);
    };

    handleFetch = () => {
        this.fetchProducts(this._input.value);
    };

    handleFileSelect = () => {
        if (!['text/csv', 'text/plain', 'application/vnd.ms-excel'].includes(this._file.files[0].type)) {
            Alert.error('not the correct file format');
            return false;
        }

        Import.fr.onload = (e) => {
            this._input.value = e.target.result;
            window.sessionStorage.setItem('last_import', e.target.result);
        };

        Import.fr.readAsText(this._file.files[0]);
    };

    handleClear = () => {
        window.sessionStorage.removeItem('last_import');
        this._input.value = '';
        this.setState({
            allSelected: true,
            products: {
                data: []
            },
            alreadySelectedVals: [],
            error: null
        });
    };

    handleQtyChange = (sku, qty) => {
        this.setState({
            products: {
                ...(this.state.products || {}),
                data: this.state.products.data.map((p) => {
                    if (p.sku === sku) {
                        p.qty = qty;
                    }
                    return p;
                })
            }
        });
    };

    handleItemSelect = (sku, selected) => {
        this.setState({
            products: {
                ...(this.state.products || {}),
                data: this.state.products.data.map((p) => {
                    if (p.sku === sku) {
                        p.is_selected = selected;
                    }
                    return p;
                })
            }
        });
    };

    selectAll = () => {
        this.setState({
            allSelected: !this.state.allSelected,
            products: {
                ...(this.state.products || {}),
                data: this.state.products.data.map((p) => {
                    p.is_selected = !this.state.allSelected;
                    return p;
                })
            }
        });
    };

    render = () => {
        let message = (
            <span>
                Upload a <code>csv</code> file with your list of ISBNs or paste in a comma separated list of ISBNs
            </span>
        );
        if (!Import.fr) {
            message = <span>Paste in a comma separated list of ISBNs.</span>;
        }

        return (
            <div className="container">
                <h4>Bulk ISBN Search</h4>
                <p>
                    This page allows you to find multiple products or titles via ISBN in one quick search. You can then
                    add these items to your primary cart all at once. This functionality is geared towards creating a
                    swift ordering experience for those who have a pre-identified list of items to order.
                </p>

                <ol>
                    <li>{message}</li>
                    <li>Click "Find Products"</li>
                    <li>Click "Add Selected Titles to Cart"</li>
                    <li>View cart to continue with standard check out process</li>
                </ol>

                {!!Import.fr && (
                    <input type="file" ref={(ref) => (this._file = ref)} onChange={this.handleFileSelect} />
                )}
                <div className="spaced-double">
                    <textarea
                        ref={(ref) => (this._input = ref)}
                        id=""
                        cols="30"
                        rows="10"
                        placeholder="1234567890, 0987654321"
                        onChange={this.inputChange}
                        defaultValue={window.sessionStorage.getItem('last_import') || ''}
                    />
                    <button className="button" onClick={this.handleFetch}>
                        Find Products
                    </button>
                    <button className="button button-danger" onClick={this.handleClear}>
                        Clear
                    </button>
                </div>

                {this.state.error && !this.state.inProgress && (
                    <div className="col-xs-12 flash-error txt-left mb-4">{this.state.error}</div>
                )}
                {!!this.state?.alreadySelectedVals?.length && !this.state.inProgress && (
                    <div className="col-xs-12 flash-notice txt-left mb-8">
                        <p className="mb-1">
                            <strong>Note:</strong> Products already in cart will not display below
                        </p>
                        <ul className="pl-6 mt-2 mb-0">
                            {this.state.alreadySelectedVals.map((value) => (
                                <li key={value}>
                                    <small>{value} is already in cart</small>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {this.state.inProgress && <Loading />}
            </div>
        );
    };
}

export default Import;
